<template>
    <v-card class="pa-3 ma-md-3">
        <v-toolbar flat color="#1d2735" dark>
            <v-icon class="white--text" style="font-size: 45px"
                >mdi-account-supervisor-circle</v-icon
            >
            <pre><v-toolbar-title><h2>Lista de equipos</h2></v-toolbar-title></pre>
        </v-toolbar>
        <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    fab
                    :to="{ path: `/guardar-equipo` }"
                    :loading="isloading"
                    :disabled="isloading"
                    color="success"
                    class="mt-2"
                    v-bind="attrs"
                    v-on="on"
                >
                    <v-icon class="white--text">mdi-plus</v-icon>
                </v-btn>
            </template>
            <span>Nuevo equipo</span>
        </v-tooltip>
        <v-row>
            <v-col cols="12" md="4">
                <v-text-field
                    prepend-icon="mdi-account-search"
                    v-model="search"
                    label="Buscar"
                ></v-text-field>
            </v-col>
        </v-row>

        <v-data-table
            :item-class="getRowClass"
            dense
            @click:row="
                (item) => {
                    $router.push(`/guardar-equipo?id=${item.id}`);
                }
            "
            :headers="headers"
            :items="equipos"
            :search="search"
            :items-per-page="15"
            item-key="id"
            class="elevation-1"
            :sort-by="['nombre']"
            :sort-desc="[false]"
        >
            <template v-slot:item.peones="{ item }">
                <span>{{ item.peones.length }}</span>
            </template>
            <template v-slot:item.action="{ item }">
                <a @click.stop="openModal(item)">
                    <v-icon
                        @click="openModal(item)"
                        small
                        class="mr-2"
                        color="red"
                        style="font-size: 25px"
                        title="BORRAR"
                        >mdi-trash-can</v-icon
                    >
                </a>
            </template>
        </v-data-table>

        <!-- Confirmacion de eliminacion -->
        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Aviso
                </v-card-title>
                <v-card-text style="text-align: center">
                    <h2>¿Estás seguro que deseas eliminar?</h2>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        large
                        @click="
                            dialog = false;
                            selectedItem = {};
                        "
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="deleteUser()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>
<script>
export default {
    data() {
        focus;
        return {
            search: "",
            headers: [
                { text: "Oficial", value: "oficial.name", sortable: false },
                {
                    text: "Observaciones",
                    value: "observaciones",
                    sortable: false,
                },
                { text: "Peones", value: "peones", sortable: false },
                { text: "Acciones", value: "action", sortable: false },
            ],
            equipos: [],
            selectedItem: 0,
            dialog: false,
        };
    },
    created() {
        this.getequipos();
    },
    methods: {
        getRowClass() {
            return "pointer";
        },
        getequipos() {
            axios.get(`api/get-equipos`).then(
                (res) => {
                    this.equipos = res.data;
                },
                (err) => {
                    this.$custom_error("Error consultando los equipos");
                }
            );
        },
        openModal(item) {
            this.selectedItem = this.equipos.indexOf(item);
            this.dialog = true;
        },
        deleteUser() {
            axios
                .get(`api/delete-equipo/${this.equipos[this.selectedItem].id}`)
                .then(
                    (res) => {
                        this.$toast.sucs("Equipo eliminado con éxito");
                        this.dialog = false;
                        this.getequipos();
                    },
                    (err) => {
                        this.$custom_error("Error eliminando el equipo");
                    }
                );
        },
    },
    computed: {
        isloading: function () {
            // return this.$store.getters.getloading
        },
    },
};
</script>
